//ANGULAR
import { Router } from '@angular/router';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';

//COMPONENTS
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../../../../goldstar-share/src/app/components/new/button/button.component';

//SERVICES
import { RoutePathResolverService } from '../../../../../../src/app/modules/services/route-path-resolver.service';
import { GsConnectService } from '../../stand-alone/gs-connect/services/gs-connect.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-reward-notification-dialog',
	standalone: true,
	imports: [CommonModule, MatDialogContent, MatDialogActions, CurrencyPipe, ButtonComponent, MatIconModule],
	templateUrl: './reward-notification-dialog.component.html',
	styleUrl: './reward-notification-dialog.component.scss',
})
export class RewardNotificationDialogComponent implements OnDestroy {
	public wasOnClosedTriggered = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<RewardNotificationDialogComponent>,
		private routePathResolverService: RoutePathResolverService,
		private gsConnectService: GsConnectService,
		private router: Router
	) {}

	ngOnDestroy(): void {
		this.dialogRef.close();
	}

	public onClose = (isSubmitting = false): void => {
		//If it's being submitted, then close and send data back.
		this.dialogRef.close(isSubmitting);
	};

	public navigateToPost = async (e: any): Promise<void> => {
		e?.preventDefault?.();

		this.gsConnectService.selectedGsConnectPostGUID.next(this.data.gsConnectPostGUID);

		const gsConnectComponentGUID = this.routePathResolverService.resolveRouterUrlGUIDFromComponentName('GsConnectComponent');
		this.router.navigate(['', gsConnectComponentGUID]);

		this.onClose();
	};

	public navigateToRewards = async (): Promise<void> => {
		const myRewardsComponentGUID = this.routePathResolverService.resolveRouterUrlGUIDFromComponentName('MyRewardsComponent');
		this.router.navigate(['', myRewardsComponentGUID]);

		this.onClose();
	};
}
